import script from "./FirmTepe.vue?vue&type=script&lang=ts&setup=true"
export * from "./FirmTepe.vue?vue&type=script&lang=ts&setup=true"

import "./FirmTepe.vue?vue&type=style&index=0&id=7e007fb4&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e007fb4"]])

export default __exports__